import React, { useEffect, useMemo, useRef, useState } from "react";
import DashboardLayout from "layout/dashboard";
import AddIcon from "assets/icons/plus.svg";
import DocSignIcon from "assets/icons/sign-document.svg";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { CustomInput } from "shared/components/allInput";
import { CustomButton, RoundButton } from "shared/components/inputButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TableContainer from "shared/Tables/TableContainer";
import { useDispatch } from "react-redux";
import {
  CreateProjectAction,
  DeleteProjectAction,
  GetProjectListAction,
  uploadAgreementAction,
} from "store/actions/ProjectActions";
import CustomBatch from "shared/components/CustomBatch";
import { getColor, getStatus } from "utils/common";
import DeleteModal from "shared/Modals/DeleteModal";
import { debounce } from "lodash";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import fileimg from "../../../assets/images/file.png";
import { showToastAction } from "store/slices/commonSlice";
import downloadIcon from "assets/icons/line-md_download.svg";
import pdfIcon from "assets/images/fi_4726010.png";
import constants from "../../../constants";

export default function ProjectManagement() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [projects, setProjects] = useState();
  const [count, setCount] = useState(0);
  const [expandedRows, setExpandedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const page = query.get("page") || 1;
  const rows = query.get("rows") || 10;
  const [first, setFirst] = useState(0);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isToDelete, setIdToDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadDialogVisible, setUploadDialogVisible] = useState(false);
  const [selectedAgreement, setSelectedAgreement] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [fileUploadKey, setFileUploadKey] = useState(0);
  const [file, setFile] = useState(null);
  const [search, setSearch] = useState("");
  const [isSearch, setIsSearch] = useState("");
  const projectId = location?.state?.id;

  useMemo(() => {
    setFirst(page * rows - rows);
  }, []);

  useEffect(() => {
    if (projectId) {
      setExpandedRows({ [projectId]: true });
    }
  }, [projectId]);

  const filterProjects = (event) => {
    const value = event.target.value;
    setGlobalFilter(value);
  };

  const projectStatusTemplate = (rowData) => {
    return (
      <div className={`project-status-${rowData.status.toLowerCase()}`}>
        {rowData?.status}
      </div>
    );
  };

  const handleUpload = (agreement, data) => {
    console.log(data, "data");
    setSelectedAgreement({
      ...agreement,
      projectId: data?._id,
    });
    console.log(selectedAgreement, "kyakarumai");
    setUploadDialogVisible(true);
  };

  const handleSelect = (e) => {
    const selectedFile = e.files[0];
    if (!selectedFile) return;

    console.log("Selected file:", selectedFile);
    setFile({
      object: selectedFile,
      name: selectedFile.name,
      size: Math.round(selectedFile.size / 1024),
      progress: 100, // Start at 0% progress
    });
    setFilePreview(URL.createObjectURL(selectedFile));
  };

  const handleClear = () => {
    if (filePreview) {
      URL.revokeObjectURL(filePreview);
    }
    setFile(null);
    setFilePreview(null);
    setFileUploadKey((prev) => prev + 1);
  };

  const handleAgreementSubmit = async () => {
    const data = {
      projectId: selectedAgreement?.projectId,
      agreementName: selectedAgreement?.documentName,
      file: file.object,
    };

    dispatch(
      uploadAgreementAction(data, setLoading, dispatch, (res) => {
        if (res && res.success) {
          handleClear();
          setUploadDialogVisible(false);
          getProjectsList(rows, page, search);
        }
      })
    );
  };

  const getDownloadUrl = (uploadLink) => {
    if (!uploadLink) return "";
    const normalizedBaseUrl = constants.baseUrl.replace(/\/+$/, "");
    const normalizedPath = uploadLink.replace(/^\/+/, "");
    return `${normalizedBaseUrl}/${normalizedPath}`;
  };

  const rowExpansionTemplate = (data) => {
    return (
      <div className="p-4">
        <div className="flex border-bottom-1 py-3">
          <p className="text-lg text-black-alpha-90">
            Project status: {getStatus(data?.projectStatus)}
          </p>
        </div>
        <p className="text-lg py-3 text-black-alpha-90 capitalize">
          Your Single “{data?.projectName}” Status of Required Paperwork
        </p>
        <div className="grid">
          <div className="col-12">
            {/* Table Header */}
            <div className="grid mb-3">
              <div className="col-3 color-verdigris">Status</div>
              <div className="col-3 color-verdigris">Task</div>
              <div className="col-3 color-verdigris">Document</div>
              <div className="col-3 color-verdigris">Rejection Reason</div>
            </div>
            {/* Data of a table */}
            {data.agreements.length > 0 ? (
              <>
                {data.agreements.map((agreement, index) => (
                  <div key={index} className="grid mb-3 align-items-center">
                    {/* {Status} */}
                    <div className="col-3">
                      <CustomBatch value={getStatus(agreement?.status)} />
                    </div>
                    {/* {Task} */}
                    <div className="col-3">
                      <span className="text-sm">{agreement?.documentName}</span>
                    </div>
                    {/* {Document } */}
                    <div className="col-3">
                      {agreement?.uploadLink ? (
                        <div className="flex align-items-center gap-2">
                          <img
                            src={pdfIcon}
                            alt="PDF"
                            style={{ width: 24, height: 24 }}
                          />
                          <span className="text-sm ellipsis-text">
                            {agreement.documentName}
                          </span>
                          <a
                            href={getDownloadUrl(agreement.uploadLink)}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            className="ml-2"
                            title="Download PDF"
                          >
                            <img
                              src={downloadIcon}
                              className="p-button-rounded p-button-text"
                              style={{ fontSize: 18 }}
                            />
                          </a>
                        </div>
                      ) : agreement?.status === "NOT_STARTED" ? (
                        <button
                          onClick={() => handleUpload(agreement, data)}
                          className="text-sm color-grey underline border-none bg-white cursor-pointer"
                        >
                          Upload Document
                        </button>
                      ) : (
                        <span className="text-sm font-medium text-green-600">
                          Contract Created
                        </span>
                      )}

                      <Dialog
                        header={null}
                        visible={uploadDialogVisible}
                        style={{
                          width: "35rem",
                          borderRadius: "1rem",
                          padding: "1px",
                        }}
                        onHide={() => {
                          setUploadDialogVisible(false);
                          handleClear();
                        }}
                        draggable={false}
                        resizable={false}
                        closable={false}
                        className="p-dialog-custom rounded-xl"
                      >
                        <div className="flex flex-column gap-4 upload-document">
                          <h3 className="text-center text-base font-bold text-black-alpha-90">
                            Upload document
                          </h3>
                          <p
                            className="text-center text-black-alpha-90 border-dashed border-2 border-400 p-6 border-round-xl flex flex-column gap-3"
                            style={{ minHeight: 340 }}
                          >
                            {!file && (
                              <>
                                Drag here or click to browser
                                <FileUpload
                                  key={fileUploadKey}
                                  mode="basic"
                                  name="file"
                                  accept="application/pdf"
                                  maxFileSize={1000000}
                                  customUpload
                                  auto
                                  chooseLabel="Select Agreement"
                                  onSelect={handleSelect}
                                  multiple={false}
                                />
                              </>
                            )}
                            {filePreview && (
                              <div
                                className="flex justify-content-center align-items-center h-full"
                                style={{ minHeight: 300 }}
                              >
                                <embed
                                  src={filePreview}
                                  type="application/pdf"
                                  width="100%"
                                  height="300px"
                                  style={{
                                    borderRadius: 8,
                                    border: "1px solid #ccc",
                                  }}
                                />
                              </div>
                            )}
                          </p>
                          {file && (
                            <div className="mt-4 bg-gray-100 p-3 border-round flex align-items-center gap-3 justify-between">
                              <div className="flex align-items-center gap-3 w-full">
                                <div className="flex flex-column w-full">
                                  <p className="font-semibold text-900">
                                    {file.name}{" "}
                                    <small className="text-500">
                                      {file.size}KB
                                    </small>
                                  </p>
                                  <ProgressBar
                                    value={file.progress}
                                    className="mt-2 h-1rem border-round"
                                  />
                                </div>
                              </div>
                              <Button
                                icon="pi pi-trash"
                                className="p-button-rounded p-button-text text-red-500"
                                onClick={handleClear}
                              />
                            </div>
                          )}
                          <div className="flex justify-content-center gap-2 mt-2">
                            <RoundButton
                              label="Cancel"
                              className="border-round-md px-6 surface-500 text-black-alpha-90"
                              onClick={() => setUploadDialogVisible(false)}
                            />
                            <RoundButton
                              className="border-round-md px-6"
                              onClick={handleAgreementSubmit}
                              disabled={!file}
                            />
                          </div>
                        </div>
                      </Dialog>
                    </div>

                    <div className="col-3">
                      {agreement?.rejectionReason && (
                        <div className="text-xs text-red-500 mt-1">
                          {agreement.rejectionReason}
                        </div>
                      )}

                      {agreement?.status === "COMPLETED" && (
                        <div className="text-xs text-green-600 mt-1 font-medium">
                          Agreement Successfully Accepted
                        </div>
                      )}

                      {agreement?.status === "IN_PROGRESS"  && (
                        <div className="text-xs text-yellow-600 mt-1 font-medium">
                          Yet Not Reviewed
                        </div>
                      )}

                      {/* {!agreement?.uploadLink &&
                        !agreement?.rejectionReason && (
                          <div className="text-xs text-blue-500 mt-1 font-medium">
                            Agreement needs to be uploaded before proceeding ✨
                          </div>
                        )} */}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="text-sm text-gray-500">No agreements found.</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const header = (
    <div className="flex flex-column gap-2 md:flex-row justify-content-between align-items-center">
      <div className="mb-3">
        <h4 className="m-0">Projects</h4>
      </div>
      <CustomInput
        name="search"
        value={search}
        onChange={({ value }) => {
          setFirst(0);
          setSearch(value);
          debouncedOnChange.current(rows, 1, value);
        }}
        isSearch={isSearch}
        placeholder="Search"
        ignoreLabel
        col={4}
        searchIcon
      />
    </div>
  );

  const handleSearch = (rows, page, search) => {
    setIsSearch(true);
    getProjectsList(rows, page, search);
  };

  const debouncedOnChange = useRef(debounce(handleSearch, 1000));

  const projectCards = [
    {
      id: 1,
      imgSrc: AddIcon,
      url: "/create-project",
      title: "Create New Project",
      description: "Create and manage a project in one place.",
    },
    {
      id: 2,
      imgSrc: DocSignIcon,
      url: "/contract-review",
      title: "e-sign a document",
      description: "Sign documents digitally on this platform.",
    },
  ];

  const columns = useMemo(() => [
    {
      name: "Project Name",
      accessor: "projectName",
      value: true,
    },
    {
      name: "Primary Artist",
      accessor: "primaryArtist",
      value: true,
      frozen: true,
    },
    {
      name: "Status",
      accessor: "projectStatus",
      value: true,
      body: (options) => (
        <CustomBatch value={getStatus(options?.projectStatus)} />
      ),
    },
    {
      name: "Project Type",
      accessor: "projectType",
      value: "projectType",
    },
    {
      name: "Task Overview",
      accessor: "notStartedAgreements",
      value: true,
      className: "capitalize",
      body: (rowData) => `${rowData.notStartedAgreements} Not Started`,
    },
  ]);

  const allowExpansion = (rowData) => {
    return rowData?.agreements?.length > 0;
  };

  useEffect(() => {
    getProjectsList(rows, page, "");
  }, []);

  const getProjectsList = (rows, page, search) => {
    dispatch(
      GetProjectListAction(rows, page, search, setIsSearch, dispatch, (res) => {
        setProjects(res?.list);
        setCount(res?.count);
        navigate(`/project-management?page=${page}&rows=${rows}`);
      })
    );
  };

  const onPageChange = (e) => {
    getProjectsList(e.rows, e.page + 1, "");
    setFirst(e.first);
  };

  const onDelete = () => {
    dispatch(
      DeleteProjectAction(
        isToDelete,
        setLoading,
        setDeleteModal,
        dispatch,
        (res) => {
          getProjectsList(rows, page, search);
        }
      )
    );
  };

  return (
    <>
      <div className="mb-3">
        <h2>Project Management</h2>
      </div>
      <div className="grid mb-3">
        {projectCards.map((card) => (
          <div className="col-12 md:col-6">
            <Link to={card.url}>
              <div
                key={card.id}
                className="flex align-items-center border-1 p-3 border-round-md border-gray-500 gap-3"
              >
                <div
                  className="flex align-items-center justify-content-center border-circle bg-gray-300"
                  style={{ minWidth: "64px", height: "64px" }}
                >
                  <img src={card.imgSrc} alt={card.title} />
                </div>
                <div>
                  <p className="text-xl text-black-alpha-90 font-bold mb-2">
                    {card.title}
                  </p>
                  <p className="text-lg font-normal text-gray-600">
                    {card.description}
                  </p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
      <TableContainer
        list={projects}
        columns={columns}
        allowExpansion={allowExpansion}
        rowExpansionTemplate={rowExpansionTemplate}
        expandedRows={expandedRows}
        setExpandedRows={setExpandedRows}
        header={header}
        count={count}
        first={first}
        rows={rows}
        outOf={rows * page > count ? count : rows * page}
        onPageChange={onPageChange}
        onDelete={(id) => {
          setDeleteModal(true);
          setIdToDelete(id);
        }}
        onEdit={(id) => navigate(`/edit-project/${id}`)}
      />
      <DeleteModal
        isOpen={deleteModal}
        setIsOpen={setDeleteModal}
        onSubmit={onDelete}
        loading={loading}
        item={"project"}
      />
    </>
  );
}
